import api from '@config/api';
import type { AuditLog, AuditQueryParams } from '../types';
import type { PaginatedResponse } from '@common/types/api';

export const auditService = {
  getLogs: async (params: AuditQueryParams = {}): Promise<PaginatedResponse<AuditLog>> => {
    const response = await api.get('/audit', { params });
    return response.data;
  },
};
